module.exports = __webpack_public_path__ + "img/youtube.cc84fe54.svg";